"use strict";

module.exports = function (s) {
  return new Uint8Array(atob(s).split('').map(function (c) {
    return c.charCodeAt(0);
  }));
};